document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('.site-header-wrap');
  const onScroll=()=>header?.classList.toggle('is-scrolled',window.scrollY>8);
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});
  const menu=document.querySelector('[data-mobile-nav]');
  const toggle=document.querySelector('[data-menu-toggle]');
  const close=document.querySelector('[data-menu-close]');
  const setMenu=open=>{menu?.classList.toggle('is-open',open);document.body.classList.toggle('menu-open',open);toggle?.setAttribute('aria-expanded',String(open))};
  toggle?.addEventListener('click',()=>setMenu(true));close?.addEventListener('click',()=>setMenu(false));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')setMenu(false)});
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('revealed');observer.unobserve(entry.target)}}),{threshold:.12});
  document.querySelectorAll('[data-reveal]').forEach(node=>observer.observe(node));
});
